/**
 * Initializes Vue components.
 */
// Init Vue.
import Vue from 'vue';

window.Vue = Vue;

$(() => {
    if( !$('.vue-app').length ) {
        return;
    }

    // Init vue app.
    window.vueApp = new Vue({
        el: '.vue-app'
    });
});
